import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Text,
  Heading,
  Button
} from '@chakra-ui/react';
import { useRef } from 'react';

export default function FollowersChangeAlertDialog({ disclosure, onClose }) {
  const { isOpen: isFollowersAlertOpen, onClose: onCloseFollowersAlert } = disclosure;
  const followersAlertCancelRef = useRef();

  return (
    <AlertDialog
      isOpen={isFollowersAlertOpen}
      isCentered
      leastDestructiveRef={followersAlertCancelRef}
      onClose={() => {
        onClose();
        onCloseFollowersAlert();
      }}
    >
      <AlertDialogOverlay>
        <AlertDialogContent
          pt={3}
          pb={1}
          borderRadius='lg'
        >
          <AlertDialogHeader>
            <Heading size='md'>Lens Follower Warning</Heading>
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              Followers will have access to insights from past and future meetings that you have
              access to. Meetings marked &quot;Attendees only&quot; will not be shared, unless you
              are an attendee. This action cannot be undone after you save the lens.
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              size='reskinLg'
              variant='reskinSecondary'
              colorScheme='critical'
              ref={followersAlertCancelRef}
              onClick={() => {
                onClose();
                onCloseFollowersAlert();
              }}
              ml={3}
            >
              Confirm
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
